import {NavigationType, getHeadlessUrl} from '@wix/wix-to-headless-redirect-client'
import {IWixAPI} from '@wix/yoshi-flow-editor'
import {Dispatch} from 'redux'
import {getEventListPageUrl} from '../services/navigation'
import {CommonStoreExtraArgs, GetCommonState} from '../types/state'
import {getLanguage, getLocale, getTimezone, isEditor, isMobile, isPreview, isSite} from '../utils/wix-code-api'

export const SET_BASE_ENVIRONMENT = 'SET_BASE_ENVIRONMENT'
export const SET_FORM_FACTOR = 'SET_FORM_FACTOR'
const HEADLESS_QUERY_PARAM = 'headlessExternalUrls'

export const setBaseEnvironment =
  () =>
  async (dispatch: Dispatch, getState: GetCommonState, {wixCodeApi}: CommonStoreExtraArgs) => {
    const state = getState()

    const headless = Boolean(wixCodeApi.location.query?.[HEADLESS_QUERY_PARAM])
    const headlessOrigin = getHeadlessUrlByName(wixCodeApi, NavigationType.HOME)
    const hasHeadlessTYP = headless && Boolean(getHeadlessUrlByName(wixCodeApi, NavigationType.EVENTS_THANK_YOU_PAGE))
    const homePageUrl = headless ? headlessOrigin : wixCodeApi.location.baseUrl
    const eventListPageUrl = await getEventListPageUrl(wixCodeApi)

    dispatch({
      type: SET_BASE_ENVIRONMENT,
      payload: {
        seo: wixCodeApi.seo.isInSEO(),
        locale: getLocale(wixCodeApi) || state.siteSettings.locale,
        language: getLanguage(wixCodeApi),
        timezone: getTimezone(wixCodeApi),
        mobile: isMobile(wixCodeApi),
        editor: isEditor(wixCodeApi),
        preview: isPreview(wixCodeApi),
        site: isSite(wixCodeApi),
        eventListPageUrl: eventListPageUrl?.url ?? homePageUrl,
        eventListPageRelativeUrl: eventListPageUrl?.relativeUrl,
        homePageUrl,
        headless,
        hasHeadlessTYP,
      },
    })
  }

export const setFormFactor = (formFactor: string) => ({
  type: SET_FORM_FACTOR,
  payload: formFactor === 'Mobile',
})

const getHeadlessUrlByName = (wixCodeApi: IWixAPI, logicalName: NavigationType) =>
  getHeadlessUrl({
    query: wixCodeApi.location.query,
    baseUrl: wixCodeApi.location.baseUrl,
    navParams: {
      logicalName,
    },
  })
